module.exports = __webpack_public_path__ + "media/AUDIO 05.7238f83f.mp3";